import { FinancialCapex, FinCapexPropName } from '../../../../models/project/financial/financial-capex.model';
import { GenericErrors, ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import { ValidationInterface } from '../../validation.interface';

export class FinancialCapexValidation implements ValidationInterface {
  /** The current financial capex obj that is being validated */
  private readonly capex: FinancialCapex;

  /**
   * Sets the capex obj that will be used for validation
   * @param capex will be used to set the current capex obj
   */
  constructor(capex: FinancialCapex) {
    if (!capex) {
      throw Error('invalid capex item provided for validation');
    }
    this.capex = new FinancialCapex(capex);
  }

  /**
   * Get a validation unit containing the validation data for the current capex obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.capex) throw Error('unable to validate capex item');
    const validationUnit = new ProjectValidationUnit();
    if (this.capex.name) {
      validationUnit.setValid(FinCapexPropName.name);
    } else {
      validationUnit.setInvalid(FinCapexPropName.name,
        [GenericErrors.MissingName]);
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.capex.cost).getValidation(),
      FinCapexPropName.cost
    );
    if (this.capex.connectionToggle) {
      validationUnit.addModuleResults(
        new UnitValueValidation(this.capex.quantity).getValidation(),
        FinCapexPropName.quantity
      );
      validationUnit.addModuleResults(
        new UnitValueValidation(this.capex.period).getValidation(),
        FinCapexPropName.period
      );
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.capex.lifetime).getValidation(),
      FinCapexPropName.lifetime
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current financial capex obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
